import _, { map } from 'lodash';

/**
 * convert data in CSV required format
 * inputs are data and table columns array
 */
export const renderCSVData = (data, cols) =>
  _.map(data, (d) => {
    const renderedRow = {};
    cols.forEach((c) => {
      if (c.accessor === 'action' || c.key === 'action') return;
      const dataKey = typeof c.accessor === 'string' ? c.accessor : c.accessor.join('.');
      const dataValue = _.get(d, dataKey, '');
      if (typeof c.render === 'function') {
        const renderedText = c.render(dataValue, d);
        // for i18n
        let { title } = c;
        if (typeof c.title !== 'string') {
          title = c.title.props.defaultMessage;
        }
        if (typeof renderedText === 'string') {
          renderedRow[title] = renderedText;
        } else if (typeof renderedText?.props?.children === 'string') {
          renderedRow[title] = renderedText?.props?.children;
        } else if (typeof renderedText?.props?.title === 'string') {
          renderedRow[title] = renderedText?.props?.title;
        } else if (typeof renderedText?.props?.children?.props?.defaultMessage === 'string') {
          renderedRow[title] = renderedText?.props?.children?.props?.defaultMessage;
        } else if (Array.isArray(renderedText?.props?.title)) {
          renderedRow[title] = renderedText?.props?.title.join(',');
        } else if (dataValue === null) {
          renderedRow[title] = '';
        } else if (typeof renderedText === 'number') {
          renderedRow[title] = renderedText;
        } else if (renderedText?.props?.children?.length) {
          renderedRow[title] = map(renderedText?.props?.children, (s) => s?.props?.children);
        } else if (renderedText?.length) {
          renderedRow[title] = renderedText.map((s) => s);
        } else if (renderedText?.length === 0) {
          renderedRow[title] = '';
        } else if (!renderedText?.props?.children?.length) {
          renderedRow[title] = '';
        } else {
          renderedRow[title] = 'Unable to render this field.';
        }
      } else if (dataValue) {
        // for i18n
        let { title } = c;
        if (typeof c?.title !== 'string') {
          title = c?.title?.props?.defaultMessage;
        }
        renderedRow[title] = dataValue;
      }
    });
    return renderedRow;
  });

// returns fixed query object
export const fixTimeInQuery = (v) =>
  typeof v === 'string' && v?.includes(['T']) && v.includes([' ']) ? v.replace(' ', '+') : v;
export const queryObjToObj = (queryObj) => {
  const newObj = {};
  _.map(queryObj, (v, k) => {
    newObj[k] = v.includes('[') ? JSON.parse(v).map(fixTimeInQuery) : fixTimeInQuery(v);
  });
  return newObj;
};

// returns fixed query object
export const objToQueryObj = (obj) => {
  const newObj = {};
  _.map(obj, (v, k) => {
    if (v === null || _.isEmpty(v)) {
      return;
    }
    newObj[k] = typeof v === 'string' ? v : JSON.stringify(v);
  });
  delete newObj.siteId;
  return newObj;
};

export const getFlattenedKeys = (obj, key) => {
  const keys = _.map(obj, (v, k) => {
    const newKey = key ? `${key}.${k}` : k;
    if (v == null || typeof v !== 'object') {
      return newKey;
    }
    return getFlattenedKeys(v, newKey);
  });
  return _.flatten(keys);
};

export const isValidTransformerFunction = (functionToCheck) => {
  try {
    return (
      functionToCheck &&
      // eslint-disable-next-line no-eval
      eval(`typeof ${functionToCheck}`) === 'function' &&
      functionToCheck.startsWith('function transformer(data) {') &&
      functionToCheck.endsWith('return data;\n}')
    );
  } catch {
    return false;
  }
};

export const testApiCall = async ({ url, method = 'get', headers = null, body = null }) => {
  let data = {};
  let error = false;
  const opt = {
    method,
    ...(headers && { headers }),
    ...(body && { body }),
  };
  if (url) {
    try {
      const res = await fetch(url, opt);
      data = res;
    } catch (err) {
      error = true;
      data = err;
    }
  }

  return { data, error };
};

export const getBuildId = () => {
  const scripts = document.getElementsByTagName('script');
  const splittedDetails = scripts[scripts.length - 1].outerHTML.split('.');
  return splittedDetails.length > 2 ? splittedDetails[1] : 'dev';
};

export const getMenuItem = ({ label, key, icon, children, type }) => ({
  key,
  icon,
  children,
  label,
  type,
});

export const validateDateOrTime = (dataArray) => {
  let truthyStatus = false;
  // eslint-disable-next-line array-callback-return
  dataArray.map((tariff, i) => {
    if (tariff.timeStart >= tariff.timeEnd || dataArray[i - 1]?.timeEnd >= tariff.timeStart) {
      truthyStatus = true;
    }
  });
  return truthyStatus;
};
